import styles from "./ExpeditionStatusBar.module.css";
import rocket from "/Expeditions/rocket.svg";
import { Expedition } from "../../../../types";
import { TimeDisplay } from "../../../../../../../utils/TimeDisplay";
import { TimeDetails } from "../../../../../../../utils/timeFormatter";
import { getExpeditionInfo } from "../../../../../../Services/Requests";
import { useUpdateProgressBar } from "../../../../hooks/useUpdateProgressBar";
import { motion } from "framer-motion";

type ExpeditionStatusBarProps = {
	expedition: Expedition;
	expeditionIsDone: boolean;
	progress: number | null;
	setExpedition: React.Dispatch<React.SetStateAction<Expedition | null>>;
	setProgress: React.Dispatch<React.SetStateAction<number | null>>;
	setExpeditionIsDone: React.Dispatch<React.SetStateAction<boolean>>;
	setLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

const customFormatTimeString = (
	timeLeft: string | TimeDetails
): string | undefined => {
	if (typeof timeLeft === "string") {
		if (timeLeft.includes(".")) {
			return "Время закончилось";
		}

		return timeLeft
			.replace(/(\d+)д/g, "$1 дней")
			.replace(/(\d+)ч/g, "$1 час")
			.replace(/(\d+)м/g, "$1 мин.")
			.replace(/(\d+)с/g, "$1 сек");
	}

	return undefined;
};

export const ExpeditionStatusBar: React.FC<ExpeditionStatusBarProps> = ({
	expedition,
	progress,
	expeditionIsDone,
	setExpedition,
	setProgress,
	setExpeditionIsDone,
	setLoading,
}) => {
	const reRenderExpedition = async () => {
		const data = await getExpeditionInfo(1);
		setExpedition(data as Expedition);
	};

	const { updatedProgressBar } = useUpdateProgressBar({
		progress,
		data: expedition,
		startedAt: expedition?.user_metadata?.started_at,
		endedAt: expedition?.user_metadata?.ended_at,
		isDone: expeditionIsDone,
		reRenderFunction: reRenderExpedition,
		setProgress,
		setIsDone: setExpeditionIsDone,
		setLoading,
	});

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 0.5 }}
			className={`${styles.statusContainer}`}
		>
			<div
				className={styles.progress}
				style={{ width: `${updatedProgressBar}%` }}
			>
				<img className={styles.rocketIcon} src={rocket} alt='rocket' />
				<span className={styles.divider} />
			</div>
			<div className={styles.status}>
				<span className={styles.statusText}>В работе...</span>
				<span className={styles.timeLeft}>
					<TimeDisplay
						endDate={expedition?.user_metadata?.ended_at}
						render={customFormatTimeString}
					/>
				</span>
			</div>
		</motion.div>
	);
};
